import { useEffect, useState, useCallback } from "react";
import { getLogo, getUser } from "../../../shared/services/services";
import { IUser } from "../../../shared/services/interface";
import { useUser } from "../components/UserContext";
import { IS_STANDALONE } from "src/features/auth/axiosConfig";
import { notifyError } from "src/assets/toastService";
import { useThemeSetup } from "src/shared/modules/admin/auth/hooks/useThemeSetup";

const useUsers = () => {
  const { setUser } = useUser();
  const [users, setUsers] = useState<IUser>();
  const [loading, setLoading] = useState<boolean>(true);
  const { setupTheme } = useThemeSetup()

  const loadUsers = useCallback(() => {
    setLoading(true);

    getUser()
      .then((res) => {
        const filtered = res.data.user_details;
        if (filtered.organization_name) {
          setupTheme(filtered.organization_name);
        }

        if (!filtered?.businessLogo) {
          setUsers(filtered);
          setUser(filtered); return
        }

        const imageLogo = filtered.businessLogo;

        if (IS_STANDALONE) {
          const data = { ...filtered, companyLogo: `data:image/png;base64,${imageLogo}` }
          setUsers(data);
          setUser(data);
        }

        getLogo(filtered.businessLogo)
          .then((response: any) => {
            console.log(response.data)
            const blob = new Blob([response.data], { type: "image/png" });
            const imageUrl = URL.createObjectURL(blob);
            const data = { ...filtered, companyLogo: imageUrl }
            setUsers(data);
            setUser(data);
          })
          .catch(() => {
            notifyError("Logo getting error")
            setUsers(filtered);
            setUser(filtered);
          });
        setUsers(filtered);
        setUser(filtered);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [setUser]);

  // Load users on mount
  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  return { users, loading, reload: loadUsers };
};

export default useUsers;
